// i18n keys of the template preview on a client's chart of accounts (batch 5 round 7, COA-4 for the live
// template / COA-2): src/components/Bookkeeping/TemplateSync.tsx, opened by "Sync from template" on
// src/components/Bookkeeping/ChartOfAccounts.tsx — en / zh / th. ⛔ Fill all three: an empty value falls
// back or renders blank. ⛔ No `_plural` (dead in i18next 23): the counts here are written "… ({{n}})" and
// "…: {{n}}", which read right for any n.
// ⛔ ONLY THE SCREEN'S OWN WORDS. Codes, account names and the template's type words are shown as stored.
export const en: Record<string, string> = {
  coas_title: 'Template accounts this chart does not have',
  coas_intro: 'Tick the accounts to add, then Add selected. A template account this chart removed or renumbered is never offered again.',
  coas_admin_only: 'Only an administrator can add template accounts to a chart that already has accounts. You can see what would be added.',
  coas_loading: 'Loading the template…',
  coas_nothing: 'Nothing to add: every template account is on this chart, or was removed or renumbered here on purpose.',
  coas_select_all: 'Select all',
  coas_select_none: 'Clear',
  coas_add_selected: 'Add selected ({{n}})',
  coas_added: 'Added from the template: {{n}}',
  coas_close: 'Close',
  coas_pick: 'Add {{code}} {{name}}',
  coas_conflicts_title: 'Code already used on this chart — not added ({{n}})',
  coas_conflicts_tip: 'Two live accounts cannot share a code. If the template account is wanted, renumber or remove the account holding the code first.',
  coas_held_by: 'held by {{code}} {{name}}',
  coas_held_own: 'an account this client created',
  coas_held_copy: 'a renumbered copy of another template account',
  coas_removed_all: 'Every account on this chart has been removed, so it is not started again from the template. Open it to add accounts, or to see what the template could still add (an administrator approves).',
};

export const zh: Record<string, string> = {
  coas_title: '本科目表尚未包含的模板科目',
  coas_intro: '勾选要添加的科目,再点「添加所选」。本科目表删除过或改过代码的模板科目不会再被提议。',
  coas_admin_only: '只有管理员可以往已有科目的科目表里添加模板科目。你可以查看将会添加的内容。',
  coas_loading: '正在读取模板…',
  coas_nothing: '没有可添加的科目:模板里的科目都已在本科目表中,或是在这里被有意删除或改了代码。',
  coas_select_all: '全选',
  coas_select_none: '清除',
  coas_add_selected: '添加所选({{n}})',
  coas_added: '已从模板添加:{{n}}',
  coas_close: '关闭',
  coas_pick: '添加 {{code}} {{name}}',
  coas_conflicts_title: '代码已被本科目表占用 — 不添加({{n}})',
  coas_conflicts_tip: '两个在用科目不能共用一个代码。如需这个模板科目,请先为占用该代码的科目改代码或将其删除。',
  coas_held_by: '被 {{code}} {{name}} 占用',
  coas_held_own: '该客户自建的科目',
  coas_held_copy: '另一个模板科目改了代码后的副本',
  coas_removed_all: '本科目表的科目已全部删除,因此不会再从模板重新开始。展开后可以添加科目,或查看模板还能添加哪些科目(由管理员批准)。',
};

export const th: Record<string, string> = {
  coas_title: 'บัญชีในแม่แบบที่ผังบัญชีนี้ยังไม่มี',
  coas_intro: 'ทำเครื่องหมายบัญชีที่ต้องการเพิ่ม แล้วกด เพิ่มรายการที่เลือก บัญชีในแม่แบบที่ผังบัญชีนี้เคยลบหรือเปลี่ยนรหัสแล้วจะไม่ถูกเสนออีก',
  coas_admin_only: 'เฉพาะผู้ดูแลระบบเท่านั้นที่เพิ่มบัญชีจากแม่แบบลงในผังบัญชีที่มีบัญชีอยู่แล้วได้ คุณดูได้ว่าจะมีบัญชีใดถูกเพิ่ม',
  coas_loading: 'กำลังอ่านแม่แบบ…',
  coas_nothing: 'ไม่มีบัญชีให้เพิ่ม: บัญชีในแม่แบบอยู่ในผังบัญชีนี้ครบแล้ว หรือถูกลบหรือเปลี่ยนรหัสที่นี่โดยตั้งใจ',
  coas_select_all: 'เลือกทั้งหมด',
  coas_select_none: 'ล้าง',
  coas_add_selected: 'เพิ่มรายการที่เลือก ({{n}})',
  coas_added: 'เพิ่มจากแม่แบบแล้ว: {{n}}',
  coas_close: 'ปิด',
  coas_pick: 'เพิ่ม {{code}} {{name}}',
  coas_conflicts_title: 'รหัสนี้มีบัญชีอื่นในผังบัญชีนี้ใช้อยู่แล้ว — ไม่เพิ่ม ({{n}})',
  coas_conflicts_tip: 'บัญชีที่ใช้งานอยู่สองบัญชีใช้รหัสเดียวกันไม่ได้ หากต้องการบัญชีนี้จากแม่แบบ ให้เปลี่ยนรหัสหรือลบบัญชีที่ใช้รหัสนั้นอยู่ก่อน',
  coas_held_by: 'ใช้อยู่โดย {{code}} {{name}}',
  coas_held_own: 'บัญชีที่ลูกค้ารายนี้สร้างเอง',
  coas_held_copy: 'สำเนาของบัญชีแม่แบบอื่นที่ถูกเปลี่ยนรหัส',
  coas_removed_all: 'บัญชีทั้งหมดในผังบัญชีนี้ถูกลบแล้ว จึงไม่เริ่มต้นใหม่จากแม่แบบอีก เปิดดูเพื่อเพิ่มบัญชี หรือดูว่าแม่แบบยังเพิ่มบัญชีใดได้อีก (ผู้ดูแลระบบเป็นผู้อนุมัติ)',
};
